import { useEffect, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { MailX } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// PRD 19 §247 / prototype signup.html §228-242 — invitation link expired view.
// Renders a centered card (icon + title + body + primary button) instead of an
// inline banner. The body interpolates <strong>/<br> via i18next Trans so the
// "유효 기간(7일)" and "재발송" emphasis matches the prototype verbatim.
export const SignupExpiredCard = () => {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const cardRef = useRef<HTMLDivElement>(null);

  // Pull focus to the card so screen readers + keyboard users land on the
  // page-level state change instead of dwelling on stale fields.
  useEffect(() => {
    cardRef.current?.focus();
  }, []);

  return (
    <div
      ref={cardRef}
      className="signup-page__expired"
      role="alert"
      aria-live="assertive"
      tabIndex={-1}
    >
      <div className="signup-page__expired-icon">
        <MailX size={28} />
      </div>
      <h2 className="signup-page__expired-title">{t('signup.expired.title')}</h2>
      <p className="signup-page__expired-desc">
        <Trans
          i18nKey="signup.expired.body"
          ns="auth"
          components={{ strong: <strong />, br: <br /> }}
        />
      </p>
      <div className="signup-page__expired-actions">
        <button
          type="button"
          className="btn btn-default btn-primary"
          onClick={() => navigate('/login')}
        >
          {t('signup.expired.action')}
        </button>
      </div>
    </div>
  );
};
